import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { WsDialog, WsDialogSize } from '../WsDialog';
export interface IEmbedVimeoVideoProps {
  embedId: string;
  openDialog: boolean;
  title?: string;
  closeDialog: () => void;
}

const EmbedVimeoVideo = ({ embedId, openDialog, title, closeDialog }: IEmbedVimeoVideoProps) => (
  <WsDialog openDialog={openDialog} size={WsDialogSize.LARGE} onClose={closeDialog}>
    <CloseIcon
      sx={{
        cursor: 'pointer',
        alignSelf: 'flex-end',
        pr: 2,
        pt: 2,
      }}
      fontSize={'large'}
      onClick={closeDialog}
    />
    <Box sx={{ padding: '48% 0 0 0', position: 'relative' }}>
      <iframe
        src={`https://player.vimeo.com/video/${embedId}?autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=0&#t=0s`}
        frameBorder="0"
        allow="autoplay; fullscreen;"
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        title={title}
      />
    </Box>
  </WsDialog>
);

EmbedVimeoVideo.propTypes = {
  embedId: PropTypes.string.isRequired,
  openDialog: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default EmbedVimeoVideo;
